import { render, staticRenderFns } from "./dia.vue?vue&type=template&id=c3125040&scoped=true"
import script from "./dia.vue?vue&type=script&lang=js"
export * from "./dia.vue?vue&type=script&lang=js"
import style0 from "./dia.vue?vue&type=style&index=0&id=c3125040&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3125040",
  null
  
)

export default component.exports